import { useState } from 'react';
import { OptionButton } from '../../../../../../utils/Button';
import InstOption from '../../../../../../utils/InstOption';
import { TextCapitalize } from '../../../../../../utils/TextFormatter';
import cn from '../../../../../../utils/cn';

function TableRow({ data, isPackageOrProductInactive, openModal, handleDelete }) {
    const [itemId, setItemId] = useState(0);

    const getPricingTxt = (amount) => {
        if (amount === -101) return 'Flexible Price';
        if (amount === -102) return 'Free';
        return amount;
    };

    if (data && data.length === 0) {
        return (
            <tr className="hover:!bg-inherit">
                <td colSpan={6} className="!text-left">
                    No Pricing Found!
                </td>
            </tr>
        );
    }
    return data?.map((item) => (
        <tr
            key={item?.id}
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td className="!pl-5">
                <span>{item?.id}</span>
            </td>
            <td className="text-left">
                <span>{item?.currency?.toUpperCase()}</span>
            </td>
            <td className="text-left">
                <span>{TextCapitalize(item?.packageUnitName) || '--'}</span>
            </td>
            <td className="text-center">
                <span>{getPricingTxt(item?.amount)}</span>
            </td>
            <td className="text-center">
                <span>{item?.vatPercent}</span>
            </td>

            <td className="text-left">
                <span className={item?.status === 'active' ? 'text-success' : 'text-warning'}>
                    {TextCapitalize(item?.status) || '--'}
                </span>
            </td>
            <td>
                <div className="flex flex-row w-full justify-end relative">
                    <OptionButton
                        disabled={isPackageOrProductInactive}
                        onClick={() => setItemId(item?.id)}
                    />

                    <InstOption showMenu={itemId === item?.id} setShowMenu={setItemId}>
                        <button type="button" onClick={() => openModal('package-pricing', item)}>
                            Edit
                        </button>
                        <button type="button" onClick={(e) => handleDelete(e, item?.id)}>
                            Delete
                        </button>
                    </InstOption>
                </div>
            </td>
        </tr>
    ));
}

function TableHeader() {
    return (
        <thead>
            <tr>
                <th scope="col" width="10%" className="rounded-l-xl text-left !pl-5">
                    <span className="">ID</span>
                </th>
                <th scope="col" className="w-[100px]">
                    <span>Currency</span>
                </th>
                <th scope="col" className="w-[100px]">
                    <span>Duration</span>
                </th>
                <th scope="col" className="text-center">
                    <span>Amount</span>
                </th>
                <th scope="col" className="text-center">
                    <span>VAT</span>
                </th>
                <th scope="col" className="w-[100px]">
                    <span>Status</span>
                </th>
                <th scope="col" className="rounded-r-xl text-right !pr-8 after:!content-none w-20">
                    <span>#</span>
                </th>
            </tr>
        </thead>
    );
}

function PricingTableWeb({ data, isPackageOrProductInactive, openModal, handleDelete }) {
    return (
        <div className="pricing_modal_table">
            <table className="bik-table !w-full mb-4" cellPadding={0} cellSpacing={0}>
                <TableHeader />
                <tbody className="">
                    <TableRow
                        data={data}
                        isPackageOrProductInactive={isPackageOrProductInactive}
                        handleDelete={handleDelete}
                        openModal={openModal}
                    />
                </tbody>
            </table>
        </div>
    );
}

export default PricingTableWeb;
